<template>
  <div>
    <SectionThreeItemsHeader class="mb-6">
      <template v-slot:item-center>
        <h2>Matching</h2>
      </template>
    </SectionThreeItemsHeader>
    <div v-if="isEditing">
      <v-skeleton-loader type="list-item" />
    </div>
    <div v-else class="d-flex justify-space-between align-center">
      <p>Notify me about relevant roles, based on my preferences</p>
      <v-switch
        aria-label="In talent pool"
        :input-value="userData.inTalentPool"
        @change="handleUpdateMatching"
      />
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import SectionThreeItemsHeader from "@/components/common/SectionThreeItemsHeader/SectionThreeItemsHeader";
import { EDIT_USER } from "@/store/modules/users/actions";
import { USERS_NAMESPACE } from "@/store/modules/users";
import { mapActions } from "vuex";
import { POST_GLOBAL_MESSAGE } from "@/store/modules/global/action-types";

const { mapActions: userMapActions } = createNamespacedHelpers(USERS_NAMESPACE);

export default {
  components: {
    SectionThreeItemsHeader
  },
  props: {
    userData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isEditing: false
    };
  },
  methods: {
    ...userMapActions({
      editUser: EDIT_USER
    }),
    ...mapActions({
      postGlobalMessage: POST_GLOBAL_MESSAGE
    }),
    async handleUpdateMatching(inTalentPool) {
      this.isEditing = true;
      await this.editUser({
        id: this.userData.id,
        data: { inTalentPool }
      });
      this.postGlobalMessage({
        snackbar: true,
        type: "success",
        title: "Matching status updated"
      });
      this.isEditing = false;
    }
  }
};
</script>

<style lang="scss"></style>
